var toPrimitive = require('../internals/to-primitive');

var $TypeError = TypeError; // `ToBigInt` abstract operation
// https://tc39.es/ecma262/#sec-tobigint

module.exports = function (argument) {
  var prim = toPrimitive(argument, 'number');
  if (typeof prim == 'number') throw $TypeError("Can't convert number to bigint"); // eslint-disable-next-line es-x/no-bigint -- safe

  return BigInt(prim);
};